const Bus = {
  defaultStr: '--'
}

window.Bus = Bus

export default Bus



// WEBPACK FOOTER //
// ./src/utils/bus.js